import type { FaireProductEntity } from "../../entity_types/product";

export const p_weu3cy5hf6: FaireProductEntity = {
  token: "p_weu3cy5hf6",
  type: "product",
  name: "Cotton Pocket Tee - Cade",
  brandToken: "b_qba2f8n5gh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f9215dfe8940578090630d36f911183b48b51c7a1fb60b5adb3153ad42833d7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66980b11682fc888a1d5a0d3c2fd7faedc8aeafcf992545fc5fb750cab2b2000.jpeg",
    "https://cdn.faire.com/fastly/dffd80cceece7ab7cd03384f1a3719015636c3eb589eb41c05c665a416927ccd.jpeg",
    "https://cdn.faire.com/fastly/c0a67502ba9018ce361a482d05dfa02d3b7f95621b99515f88e13239b45301ba.jpeg",
    "https://cdn.faire.com/fastly/612afdd24cb0bbb87ac828577921cba3e5d3215aff4e9fc810432111a0f2d746.jpeg",
    "https://cdn.faire.com/fastly/45307d0050f5b885800789bb61711bd554b488c1b7cfb8cb7d2a5a0ba76bc940.jpeg",
    "https://cdn.faire.com/fastly/ea388ef5abdd0ebfd229ec3017a05559466d97018d0162579ff75d0c90f54789.png",
    "https://cdn.faire.com/fastly/6687e578fd13cca589718e2a8f5824ab19740fe825853c648c2f8df98736d5c2.png",
  ],
  priceDollars: 15.25,
  description:
    "Drama-free dressing.\n\nFeaturing a snap neckline for easy outfit changes, this super-soft tee is sure to become a wardrobe staple.\n\n * PREMIUM KNIT FABRIC - cotton pocket tees are made from ultra-soft material. Both lightweight and breathable, the premium fabric keeps you cool and comfortable. \n * BONUS FEATURES – Our cotton pocket tees feature a snap neckline, a pocket detail and a classic, cozy fit. Available in sizes 0-3m through 5T. \n * TRENDY, HIGH-QUALITY DESIGNS – At Copper Pearl, we pride ourselves on making high quality products that always look great on babies and toddlers, moms, or in your nursery. Our cotton pocket tees are simple, modern, and sure to elevate your style.",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:48.201Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
